// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"396":"dccb064fc5e056d8","411":"d5cfe6d5d2815e3b","569":"d24c1c0363489136"}[chunkId] + ".js";
};